// This code has been fully generated by an AI.
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { EmployeeDataService } from '@app/core/services/employee-data.service';
import { catchError, map, of } from 'rxjs';

/*
 * Registers the logged-in user before any page (and its requests) is created. keycloak-angular has already
 * logged the user in, because the router only starts after all app initializers (incl. keycloak.init) finished.
 */
export const employeeRegisteredGuard: CanActivateFn = () =>
  inject(EmployeeDataService)
    .register()
    .pipe(
      map(employee => !!employee),
      catchError(() => of(false)),
    );
